var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoinwhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0957 22.9688C17.6186 22.9688 22.0957 18.4916 22.0957 12.9688C22.0957 7.4459 17.6186 2.96875 12.0957 2.96875C6.57286 2.96875 2.0957 7.4459 2.0957 12.9688C2.0957 18.4916 6.57286 22.9688 12.0957 22.9688Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0957 9.46875C14.4107 8.78376 13.2044 8.3073 12.0957 8.27747M9.0957 15.9688C9.74018 16.8281 10.9385 17.3182 12.0957 17.3597M12.0957 8.27747C10.7766 8.24197 9.5957 8.83873 9.5957 10.4688C9.5957 13.4688 15.0957 11.9688 15.0957 14.9688C15.0957 16.6798 13.6319 17.4149 12.0957 17.3597M12.0957 8.27747V6.46875M12.0957 17.3597V19.4688",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinwhite);
export default __webpack_public_path__ + "static/media/coinwhite.073b2b48ee84006abe7c2600434dfe6f.svg";
export { ForwardRef as ReactComponent };